<template>
  <div ref="component" class="vue-translations" style="display:none">
    <div v-for="item in GeneralErrors" v-if="GeneralErrors && GeneralErrors.length" class="validation-advice">
      <div>{{ item }}</div>
    </div>
    <div class="new-amount rounded amount-box-on-landing-page row">
        <div class="component-header"><span v-html="header"></span></div>
            <div :class="['new-amount-left col', AmountComponentClass]">
                <amounts :isQuickRegistrationRequired="IsQuickRegistrationRequired"
                         :receiverMulticurrencyModel="ReceiverMulticurrencyModel"
                         :senderMulticurrencyModel="SenderMulticurrencyModel"
                         :sku="Sku"
                         :transferSummaryModel="TransferSummaryModel"
                         :updateCurrencyUrl="Urls.UpdateCurrencyUrl"
                         v-on:amountUpdated="handleAmountUpdated"
                         v-on:receiverCurrencyUpdated="handleReceiverCurrencyUpdated"
                         v-on:senderCurrencyUpdated="handleSenderCurrencyUpdated" />
            </div>

            <div :class="['new-amount-right col', TransferComponentClass]" v-if="ShowTransferSummary" cloak>
                <transfer-summary  :model="TransferSummaryModel"
                :regulatoryInfo="RegulatoryInfo"
                :transferHeader="TransferHeader" />
            </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  AmountsWithTransferSummaryModel,
  MulticurrencyModel,
  TransferSummaryModel
} from './Models/AmountsWithTransferSummaryModel';

import TransferSummary from './general/transferSummary.vue';
import Amounts from './general/amounts.vue';
import { fmComponentsContainer } from './../topic-components';

export default {
  name: "AmountsWithTransferSummary",
  data: function () {
    return {
      TransferSummaryModel: {} as TransferSummaryModel,
      Translations: {},
      GeneralErrors: {},
      SenderMulticurrencyModel: {} as MulticurrencyModel,
      ReceiverMulticurrencyModel: {} as MulticurrencyModel,
      Sku: "",
      TransferHeader: "",
      RegulatoryInfo: "",
      IsQuickRegistrationRequired: true,
      FetchInitialDataReady: false,
      FetchTranslationsReady: false,
      Urls: {
        UpdateCurrencyUrl: "/vue/components/amounts/multicurrency",
        FetchInitialDataUrl: "/vue/components/amounts/fetch"
      }
    }
  },
  props: {
    initialSku: String,
    senderCurrency: String,
    header: String,
    componentType: String,

  },
  components: {
    "TransferSummary": TransferSummary,
    "Amounts": Amounts,
  },
  beforeMount() {
    this.requestVerificationToken = document.getElementsByName("__RequestVerificationToken")[0];
  },
  mounted() {      
      fmComponentsContainer.$on('translationsFetched', this.handleTranslationsReady);
      this.fetchInitialData();
  },
  computed: {
      AmountComponentClass: function() {
	  
		if (this.componentType == "amount")
			return "s12 m6 l6";
			
        if (this.componentType == "amount-mini")
            return "s12 m12 l12";
			
		if (this.componentType == "amount-small")
			return "s12 m12 l12";
		
		return "s12 m6 l6";

      },
      TransferComponentClass: function() {
		
        if (this.componentType == "amount")
            return "s12 m6 l6";
			
		if (this.componentType == "amount-small")
			return "s12 m12 l12";
		
		return "";
      },
      ShowTransferSummary: function() {
			
		if (this.componentType == "amount")
			return true;
			
		if (this.componentType == "amount-small")
			return true;
			
		if (this.componentType == "amount-mini")
			return false;
      }
  },
  methods: {
    fetchInitialData() {

      if (this.Urls.FetchInitialDataUrl) {
        fetch(this.Urls.FetchInitialDataUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            senderCurrency: this.senderCurrency,
            sku: this.initialSku
          })
        })
            .then(response => {
              return response.json();
            })
            .then(response => {

              if (response.Errors) {
                this.GeneralErrors = response.Errors;
              } else {
                this.TransferSummaryModel = response.TransferSummaryModel;
                this.SenderMulticurrencyModel = response.SenderMulticurrencyModel;
                this.ReceiverMulticurrencyModel = response.ReceiverMulticurrencyModel;
                this.Sku = response.Sku;
                this.TransferHeader = response.TransferHeader;
                this.RegulatoryInfo = response.RegulatoryInfo;
                this.IsQuickRegistrationRequired = response.IsQuickRegistrationRequired;

                this.FetchInitialDataReady = true;

                this.handleInitialDataUpdated();
              }
            });
      }
    },
    handleTranslationsReady() {
      this.FetchTranslationsReady = true;
      this.handleInitialDataUpdated();
    },
    handleInitialDataUpdated() {
        if (this.FetchInitialDataReady && this.FetchTranslationsReady) {

        var parent = this.$refs.component.parentElement;

        const preloader = parent.querySelector('.component-preloader');

        if (preloader)
          preloader.remove();

        this.$refs.component.style.display = "block";
      }
    },
    handleAmountUpdated: function (senderAmount: number, totalSenderAmount: number, receiverAmount: number) {
      this.TransferSummaryModel.AmountSent = senderAmount;
      this.TransferSummaryModel.TotalChargedAmount = totalSenderAmount;
      this.TransferSummaryModel.AmountReceivable = receiverAmount;

    },
    handleSenderCurrencyUpdated: function (model: AmountsWithTransferSummaryModel) {
      this.TransferSummaryModel = model.TransferSummaryModel;
      this.ReceiverMulticurrencyModel = model.ReceiverMulticurrencyModel;
    },
    handleReceiverCurrencyUpdated: function (model: AmountsWithTransferSummaryModel) {

      this.TransferSummaryModel = model.TransferSummaryModel;
      this.SenderMulticurrencyModel = model.SenderMulticurrencyModel;
      this.TransferHeader = model.TransferHeader;
      this.Sku = model.Sku;
    }
  }
}

document.onclick = function (event) {
    const classList = (event.target as any).classList;

    const currencyClasses = ["arrowImg", "search_input_dropdown", "dropdown", "displayCurrency", "displayFlag"];

    const isCurrencyCtrl = currencyClasses.some(className => classList.contains(className));

    if (!isCurrencyCtrl)
        fmComponentsContainer.$emit('closeDropdrownMulticurrencyCtrl');
};
</script>

